import Vue from 'vue';

const state = {
  chapter: true,
  gallery: true,
  synopsis: true,
};

const getters = {
  'get-hidden-content': (state) => state,
};

const actions = {
  setChapterVisibility({ commit }, isVisible) {
    commit('setChapterVisibility', isVisible);
  },

  setGalleryVisibility({ commit }, isVisible) {
    commit('setGalleryVisibility', isVisible);
  },

  setSynopsisVisibility({ commit }, isVisible) {
    commit('setSynopsisVisibility', isVisible);
  },
};

const mutations = {
  setChapterVisibility(state, isVisible) {
    Vue.set(state, 'chapter', isVisible);
  },

  setGalleryVisibility(state, isVisible) {
    Vue.set(state, 'gallery', isVisible);
  },

  setSynopsisVisibility(state, isVisible) {
    Vue.set(state, 'synopsis', isVisible);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
